'use client'
import { getCart } from '@/helpers/Functions/cart';
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { SavedProduct } from '@/types';
import { useUser } from './UserContext';

interface CartContextType {
    cart: SavedProduct[];
    setCart: React.Dispatch<React.SetStateAction<SavedProduct[]>>;
    loading: boolean;
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
    locked: boolean;
    setLocked?: React.Dispatch<React.SetStateAction<boolean>>;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

export const useCart = () => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};

interface CartProviderProps {
    children: ReactNode;
}


export const CartProvider: React.FC<CartProviderProps> = ({ children }) => {
    const [cart, setCart] = useState<SavedProduct[]>([]);
    const [loading, setLoading] = useState(true);
    const { signedIn, setSignedIn } = useUser();
    const [locked, setLocked] = useState(false);
    async function getCartData() {
        setLoading(true);
        await getCart(signedIn, cart, setCart);
        setLoading(false);
    }
    useEffect(() => {
        if (typeof window !== 'undefined' && window !== null) {
            getCartData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signedIn]);

    return (
        <CartContext.Provider value={{ cart, setCart, loading, setLoading, locked, setLocked }}>
            {children}
        </CartContext.Provider>
    );
};
